import { render, staticRenderFns } from "./global-sales-table.vue?vue&type=template&id=1dca31ab&"
import script from "./global-sales-table.vue?vue&type=script&lang=js&"
export * from "./global-sales-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports